<!-- 案例详情 -->
<template>
    <div class="case_content_wrapper">
        <div class="case_content_item case_content_section1">
            <!-- 头部区域 -->
            <div class="top_wrapper">
                <div class="top_content_wrapper">
                    <img :src="content.detail_link"/>
                    <div class="block">
                        <div class="title">{{content.name}}</div>
                        <div class="description">{{content.title}}</div>
                        <div class="tag">
                            <el-tag 
                                v-for="(item, idx) in tags" 
                                :key="idx"
                                class="tag_item" type="info">{{item}}</el-tag>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 内容区域 -->
            <div class="bottom_wrapper">
                <div class="main_wrapper">  
                    <div class="content_wrapper">
                        <div v-for="(item, idx) in content.features" 
                            :key="idx"
                            class="main">
                            <div class="title">{{item.title}}</div>
                            <div
                                v-for="(i, idx) in item.description.split('；')" 
                                class="description">{{i}}</div>
                        </div>
                    </div>
                    <div class="guide_wrapper">
                        <div class="prev" @click="bind_jump_content(content_prev)">上一篇： {{content_prev.name}}</div>
                        <div class="next" @click="bind_jump_content(content_next)">下一篇： {{content_next.name}}</div>
                    </div>
                </div>
            </div>
        </div>
        <BottomMsg/>
    </div>    
</template>

<script>
    import Swiper from 'swiper';
    import CmsForm from '@/components/CmsForm';
    import BottomMsg from '@/components/BottomMsg';
    import data from '@/data/case.js';
    import constant from '@/util/constant';
    import axios from 'axios';
    export default {
        name: "CaseContent",
        components: {
            CmsForm,
            BottomMsg
        },
        computed: {
            // 显示标签
            tags() {
                return this.content.description && this.content.description.replace(/\s/g, '').split('|');
            }
        },
        data() {
            return {
                content: {},
                content_prev: {},
                content_next: {}
            }
        },
        watch: {
        　　'$route': function (to, from) {
                this.fetchData();
                // 复用router-view, 手动回到顶部
                window.scrollTo(0, 0);
        　　}
        },
        mounted() {
            this.fetchData();
        },
        methods: {
            fetchData() {
                axios.get(`${constant.CMS_ADS}/dsp/ow_case.json`).then((res) => {
                    // 获取具体内容数据
                    this.content_data = res.data;
                    // 获取文章编号idx
                    let content_key = this.$route.params.id;
                    let { idx, content } = this.bind_get_content(this.content_data, content_key);
                    this.content = content;
                    this.content_idx = idx;
                    this.content_prev = this.bind_get_prevandnext(this.content_data, this.content_idx, 'prev');
                    this.content_next = this.bind_get_prevandnext(this.content_data, this.content_idx, 'next');
                })
            },
            // 通过data和key找到相应的文章内容
            bind_get_content(data, key) {
                for (let i=0; i<data.length; i++) {
                    if (data[i].name_en == key) {
                        return { idx: i, content: data[i] };
                    }
                }
                return { idx: null, content: {} };
            },
            // 获取前一篇or后一篇文章的内容
            bind_get_prevandnext(data, key, flag) {
                let len = data.length;
                if (flag == 'prev') {
                    let pre_idx = key - 1;
                    if (pre_idx < 0) {
                        return {
                            name: '没有了',
                            end: true
                        }
                    } else {
                        return data[pre_idx];
                    }
                } else if (flag == 'next') {
                    let next_idx = key + 1;
                    if (next_idx > len - 1) {
                        return {
                            name: '没有了',
                            end: true
                        }
                    } else {
                        return data[next_idx];
                    }
                }
            },
            // 跳转上下篇
            bind_jump_content(content) {
                let isend = content.end;
                let idx = content.name_en;
                if (isend) {
                    this.$message({
                        message: '已经没有啦',
                        center: true,
                        type: 'error',
                        duration: 1000
                    })
                } else {
                    this.$router.push({
                        path: `/case_content/${idx}`
                    })
                }
            }
        }
    }
</script>

<style scoped>
    /* 每个img都是铺满 */
    img {
        width: 100%;
        height: 100%;
    }
    /* 整个首页的包裹样式 */
    .case_content_wrapper {
        min-width: 1280px;
        text-align: center;
        overflow: auto;
    }

    /* 页面每个部分的通用样式 */
    .case_content_item {
        overflow: hidden;
        width: 100%;
    }

    /* 第一部分的样式 */
    .case_content_section1 {
        position: relative;
    }

    /* 轮播图包裹狂 */
    .case_content_section1 .top_wrapper {
        height: 400px;
        background: #fafcff;
    }

    .top_wrapper .top_content_wrapper {
        position: relative;
        height: 100%;
        margin: auto;
        overflow: hidden;
    }

    .top_content_wrapper img {
        width: auto;
        height: auto;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        -ms-transform: translate(-50%, -50%);
    }
    /* 头部文字区域  */
    .top_content_wrapper .block {
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        -ms-transform: translateX(-50%);
        top: 65px;
    }
    /* 标题 */
    .top_content_wrapper .title {
        font-size: 24px;
        color: #18253D;
        text-align: center;
        line-height: 24px;
    }
    /* 描述 */
    .top_content_wrapper .description {
        margin-top: 18px;
        font-size: 32px;
        color: #18253D;
        text-align: center;
        line-height: 32px;
        font-weight: bold;
    }
    /* 标签 */
    .top_content_wrapper .tag {
        margin-top: 29px;
    }
    /* 标签间距 */
    .tag .tag_item {
        margin:0 6px;
    }
    /* 内容区域 */
    .case_content_section1 .bottom_wrapper {
        width: 100%;
        background: #f7f8fa;
        z-index: 100;
    }
    /* 主要文章内容样式 */
    .case_content_section1 .main_wrapper {
        z-index: 100;
        position: relative;
        top: -100px;
        padding: 96px 60px 48px 60px;
        width: 1280px;
        margin: auto;
        border-radius: 4px;
        box-shadow: 0 2px 30px 0 rgba(204,230,255,0.36);
        background: #FFFFFF;
        overflow: hidden;
    }
    /* 内容 */
    .main_wrapper .content_wrapper {
        padding: 0 150px;
        text-align: left;
    }   
    /* 主干 */
    .content_wrapper .main {
        margin-bottom: 32px;
    }
    /* 标题 */
    .content_wrapper .title {
        font-size: 18px;
        color: #18253D;
        text-align: justify;
        line-height: 40px;
    }
    /* 描述 */
    .content_wrapper .description {
        font-size: 14px;
        color: #636770;
        text-align: justify;
        line-height: 31px;
    }
    /* 导航条 */
    .main_wrapper .guide_wrapper {
        padding-top: 48px;
        border-top: 1px solid #f0f0f0;
    }

    .guide_wrapper * {
        cursor: pointer;
        font-size: 14px;
        color: #636770;
        line-height: 14px;
    }

    .guide_wrapper *:hover {
        text-decoration: underline;
    }
    /* 前一页 */
    .guide_wrapper .prev {
        margin-left: 150px;
        float: left;
    }
    /* 后一页 */
    .guide_wrapper .next {
        margin-right: 150px;
        float: right;
    }
</style>





// WEBPACK FOOTER //
// src/containers/Case/CaseContent.vue